import {RequestPageType} from "../../types/RequestPageType";
import { pageService } from "../Page/usePageService";
import {ScreenShotService} from "./ScreenShotService";

export class PageScreenShotService {
    static takePageScreenShot(): Promise<string> {
        const isMobilePageType = pageService.getPage()?.type === RequestPageType.MobilePage

        const iframe = document.getElementById("mobileView") as HTMLIFrameElement
        const iframeDocument = iframe?.contentDocument || iframe?.contentWindow?.document;
        const element = (iframeDocument ? iframeDocument.getElementById('screen-shot-container') : null)
            ?? document.getElementById('screen-shot-container')

        if (element) {
            const refElement = element.children.item(0) as HTMLElement;
            return isMobilePageType ? ScreenShotService.takeMobileScreenShot(refElement).then(value => {
                return value
            }) : ScreenShotService.takePCScreenShot(refElement).then(value => {
                return value
            });
        }
    }
}